import api from '../../api/docomo'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  get: (state) => (id) => state.all.find((b) => b.id == id)
}

const actions = {
  fetchAll ({ commit, rootGetters }) {
    const serviceAreaId = rootGetters['reservation/getServiceAreaId']
    const token = rootGetters['user/getBearerToken'](serviceAreaId)

    return new Promise((resolve) => {
      api.getBusstops(serviceAreaId, token)
        .then(busstops => {
          commit('setBusstops', busstops)
          resolve()
        })
    })
  }
}

const mutations = {
  setBusstops (state, busstops) {
    state.all = busstops
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
